import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Welcome from './pages/Welcome';
import SiteTemplateStep2 from './pages/SiteTemplateStep2';
import MSQIndex from './pages/MSQIndex';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Sites from './pages/Sites';
import AccessCodes from './pages/AccessCodes';
import AccessCodeTester from './components/AccessCodeTester';
import MSQAccreditation from './pages/MSQAccreditation';
import MSQCaseStudies from './pages/MSQCaseStudies';
import Accreditation from './pages/Accreditation';
import CaseStudy from './pages/CaseStudy';
import PDFContent from './pages/PDFContent';
import InviteList from './pages/InviteList';
import InviteContent from './pages/InviteContent';
import ConfirmationPage from './pages/ConfirmationPage';
import EmailTemplates from './pages/EmailTemplates';
import MSQAcademy from './pages/MSQAcademy';
import Academy from './pages/Academy';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import Survey from './pages/Survey';

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Welcome />} />
          <Route path="/site-template-step2" element={<SiteTemplateStep2 />} />
          <Route path="/msq-index" element={<MSQIndex />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* Site-specific routes - catch all for site slugs */}
          <Route path="/:siteSlug" element={<Welcome />} />
          
          {/* Protected Admin Routes */}
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <AdminLayout>
                <Dashboard />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/users" element={
            <ProtectedRoute>
              <AdminLayout>
                <Users />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/sites" element={
            <ProtectedRoute>
              <AdminLayout>
                <Sites />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/access-codes" element={
            <ProtectedRoute>
              <AdminLayout>
                <AccessCodes />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/access-codes-test" element={
            <ProtectedRoute>
              <AdminLayout>
                <AccessCodeTester />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/msq-accreditations" element={
            <ProtectedRoute>
              <AdminLayout>
                <MSQAccreditation />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/msq-case-studies" element={
            <ProtectedRoute>
              <AdminLayout>
                <MSQCaseStudies />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/msq-academy" element={
            <ProtectedRoute>
              <AdminLayout>
                <MSQAcademy />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/accreditation/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <Accreditation />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/case-study/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <CaseStudy />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/academy/:id" element={
            <ProtectedRoute>
              <AdminLayout>
                <Academy />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/pdf-content" element={
            <ProtectedRoute>
              <AdminLayout>
                <PDFContent />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/invite-list" element={
            <ProtectedRoute>
              <AdminLayout>
                <InviteList />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/invite-content" element={
            <ProtectedRoute>
              <AdminLayout>
                <InviteContent />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/confirmation-page" element={
            <ProtectedRoute>
              <AdminLayout>
                <ConfirmationPage />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/email-templates" element={
            <ProtectedRoute>
              <AdminLayout>
                <EmailTemplates />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/analytics" element={
            <ProtectedRoute>
              <AdminLayout>
                <Analytics />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute>
              <AdminLayout>
                <Settings />
              </AdminLayout>
            </ProtectedRoute>
          } />
          <Route path="/admin/surveys" element={
            <ProtectedRoute>
              <AdminLayout>
                <Survey />
              </AdminLayout>
            </ProtectedRoute>
          } />
          
          {/* Redirect admin root to dashboard if authenticated, otherwise to login */}
          <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
